import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'salaryPeriod' })
export class SalaryPeriodPipe implements PipeTransform {

  constructor() {}

  transform(value: any, ...args: any[]): any {
    if (value === 'annual') { return 'Per annum'; }
    if (value === 'monthly') { return 'Per month'; }
    if (value === 'hourly') { return 'Per hour'; }
    return 'Per annum (p.a.)'
  }

}
